import { stripHtmlToText } from "@salestrak/utilities";

// Block-tag check rather than a bare startsWith("<"), which would mis-classify
// plaintext like "<budget> approved" as HTML (TipTap drops it; first edit persists the loss).
export function looksLikeHtml(value: string): boolean {
  return /^<(p|h[1-6]|ul|ol|blockquote|pre|table|hr|div)[\s/>]/i.test(
    value.trim(),
  );
}

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

// Normalize a stored paragraph value to HTML for display/seed only — callers
// must NOT persist the result on load, only on a real user edit.
export function normalizeRichTextValue(value: unknown): string {
  if (value == null) return "";
  const str = String(value);
  if (str.trim() === "") return "";
  if (looksLikeHtml(str)) return str;

  return str
    .split(/\n{2,}/)
    .map((block) => `<p>${escapeHtml(block).replace(/\n/g, "<br>")}</p>`)
    .join("");
}

export function richTextLength(value: unknown): number {
  if (value == null) return 0;
  return stripHtmlToText(String(value)).length;
}

// Non-text blocks count as real content even though they strip to no visible
// text, so a doc that is only a divider/image/table isn't treated as empty.
const NON_TEXT_BLOCK_RE = new RegExp(
  "<(hr|img|table|iframe|video|audio|embed)[\\s/>]",
  "i",
);

export function isRichTextEmpty(value: unknown): boolean {
  if (value == null) return true;
  const str = String(value);
  if (NON_TEXT_BLOCK_RE.test(str)) return false;
  return stripHtmlToText(str).trim() === "";
}
